@if (form(); as formGroup) {
  <form class="flex w-full flex-col gap-8" [formGroup]="formGroup">
    <div class="mb-4 grid grid-cols-1 gap-4" formGroupName="details">
      <h2 class="!font-medium">Patient Name</h2>

      <mat-form-field class="w-full">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" required />
        @if (formGroup.details.firstNameRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Middle Name(s)</mat-label>
        <input matInput formControlName="middleName" />
        <mat-hint align="end">Optional</mat-hint>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Surname</mat-label>
        <input matInput formControlName="surname" required />
        @if (formGroup.details.surnameRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      <h2 class="!font-medium">Patient Details</h2>

      <mat-form-field class="w-full">
        <mat-label>NHI Number</mat-label>
        <input matInput formControlName="nhi" />
        <mat-hint align="end">Optional</mat-hint>
      </mat-form-field>

      <pt-iso-date-selector
        class="w-full"
        placeholder="Date of Birth"
        formControlName="dateOfBirth"
        [required]="true"
      />

      <mat-form-field class="w-full">
        <mat-label>Gender</mat-label>
        <mat-select formControlName="gender" required>
          @for (option of genderOptions; track option.code) {
            <mat-option [value]="option.label">{{ option.code }}</mat-option>
          }
        </mat-select>
        @if (formGroup.details.genderRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Ethnicity</mat-label>
        <mat-select formControlName="ethnicityCode" required>
          @for (option of ethnicityOptions; track option.code) {
            <mat-option [value]="option.code">{{ option.label }}</mat-option>
          }
        </mat-select>
        <mat-hint>
          This information is collected for statistical reasons only, to help
          ACC develop services that are culturally appropriate.
        </mat-hint>
        @if (formGroup.details.ethnicityCodeRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      @if (formGroup.details.displayOtherEthnicity) {
        <mat-form-field class="w-full">
          <mat-label>Other Ethnicity</mat-label>
          <input matInput formControlName="otherEthnicity" required />
          @if (formGroup.details.otherEthnicityRequiredError) {
            <mat-error>This field is required</mat-error>
          }
        </mat-form-field>
      }
    </div>

    <div class="grid grid-cols-1 gap-4" formGroupName="contact">
      <h2 class="!font-medium">Contact Details</h2>

      <mat-form-field class="w-full">
        <mat-label>Mobile Phone</mat-label>
        <input matInput formControlName="mobilePhone" />
        <mat-hint>
          Include the network code but no spaces or parentheses
        </mat-hint>
        <mat-hint align="end">Optional</mat-hint>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Home Phone</mat-label>
        <input matInput formControlName="homePhone" />
        <mat-hint>Include the area code, but no spaces or parentheses</mat-hint>
        <mat-hint align="end">Optional</mat-hint>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Work Phone</mat-label>
        <input matInput formControlName="workPhone" />
        <mat-hint>Include the area code, but no spaces or parentheses</mat-hint>
        <mat-hint align="end">Optional</mat-hint>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Email Address</mat-label>
        <input matInput formControlName="emailAddress" type="email" />
        <mat-hint align="end">Optional</mat-hint>
        @if (formGroup.contact.emailAddressValidationError) {
          <mat-error>Invalid email format</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="grid grid-cols-1 gap-4" formGroupName="address">
      <h2 class="!font-medium">Home Address</h2>

      <pr-address-input
        label="Search"
        [hideManualEntry]="true"
        [formControl]="addressCtrl"
      />

      <mat-form-field class="w-full">
        <mat-label>Address Line 1</mat-label>
        <input matInput formControlName="line1" required />
        @if (formGroup.address.line1RequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Address Line 2</mat-label>
        <input matInput formControlName="line2" />
        <mat-hint align="end">Optional</mat-hint>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Suburb</mat-label>
        <input matInput formControlName="suburb" />
        <mat-hint align="end">Optional</mat-hint>
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>City</mat-label>
        <input matInput formControlName="city" required />
        @if (formGroup.address.cityRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Post Code</mat-label>
        <input matInput formControlName="postCode" required />
        @if (formGroup.address.postCodeRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="w-full">
        <mat-label>Country</mat-label>
        <input
          matInput
          formControlName="country"
          required
          value="New Zealand"
        />
        @if (formGroup.address.countryRequiredError) {
          <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
    </div>
  </form>
}
